module.exports = {
    UpdateActivityInfo: "UpdateActivityInfo"        //更新活跃度
    , UpdateSingleQuest: "UpdateSingleQuest"        //自身任务数据更新时间
    , UpdateTaskList: "UpdateTaskList"              //更新整个任务列表
    , UpdateFeatList: "UpdateFeatList"              //更新成就列表
    , UpdateUIRedStatus: "UpdateUIRedStatus"        //更新日常面板的红点状态


    ,UpdateMainQuestTask:"UpdateMainQuestTask"         //主线任务更新
    
};